<template>
  <BaseWrapper>
    <Loading v-if="loading" />

    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <SearchWarehouseInput
          :inset="false"
          :warehouse-type="null"
          modal-type="office"
          v-model="filter.warehouse"
          @change="loadStocks"
        />
        <Search v-model="filter.search" @input="loadStocks" />
      </div>
      <Datatable
        :columns="tableColumns"
        color="yellow"
        :total="stocks.meta.page.total"
        :perPage="stocks.meta.page.perPage"
        :currentPage="stocks.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="stock in stocks.data"
            :key="stock.id"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-gray-50']"
            @click="onOpenDetail(stock)"
          >
            <td :class="classes.td">
              <strong class="text-gray-900">{{
                stock.attributes.product_code
              }}</strong>
            </td>
            <td :class="classes.td">{{ stock.attributes.product_name }}</td>
            <td :class="classes.td">{{ stock.attributes.warehouse_code }}</td>
            <td :class="classes.td">
              {{ stock.attributes.is_point ? 'P' : 'N' }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.stock_qty }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.free_qty }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.stock_ordered }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.free_ordered }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.stock_real }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ stock.attributes.free_real }}
            </td>
          </tr>
        </template>
      </Datatable>
    </div>

    <ViewStockModal
      :stock-id="detailModal.id"
      :visible="detailModal.visible"
      :columns="detailColumns"
      @close="detailModal.visible = false"
    />
  </BaseWrapper>
</template>

<script>
import SearchWarehouseInput from '../../../../components/warehouse/search-warehouse-input.vue';
import Search from '../../../../components/base/Search.vue';
import ViewStockModal from '../../../../components/stock/view-stock-modal.vue';
import { requestMixin } from '../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: { SearchWarehouseInput, Search, ViewStockModal },
  data() {
    return {
      detailModal: {
        visible: false,
        id: null,
      },
      filter: {
        search: null,
        warehouse: {
          id: null,
          code: null,
          name: null,
          searchCode: null,
          originalCode: null,
          area: {
            id: null,
            code: null,
          },
        },
      },
      loading: true,
      stocks: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    detailColumns() {
      return [
        'product_code',
        'product_name',
        'stock_qty',
        'expired_qty',
        'damaged_qty',
        'suitable_for_sale_qty',
        'unsuitable_for_sale_qty',
        'reimburse_qty',
        'free_qty',
        'order_status',
        'pre_order_status',
        'weight',
        'qrcode',
        'is_published',
      ];
    },
    tableColumns() {
      return [
        { id: 'product_code', name: 'Kode Barang' },
        { id: 'product_name', name: 'Nama Barang' },
        { id: 'warehouse_code', name: 'Kode Gudang' },
        { id: 'is_point', name: 'P/N' },
        { id: 'stock_qty', name: 'Stok di Gudang', theadClass: 'text-right' },
        { id: 'free_qty', name: 'Stok Promo', theadClass: 'text-right' },
        {
          id: 'stock_ordered',
          name: 'Jumlah diorder',
          theadClass: 'text-right',
        },
        {
          id: 'free_ordered',
          name: 'Jumlah Order Promo',
          theadClass: 'text-right',
        },
        {
          id: 'stock_available',
          name: 'Stok Tersedia',
          theadClass: 'text-right',
        },
        {
          id: 'free_available',
          name: 'Stok Promo Tersedia',
          theadClass: 'text-right',
        },
      ];
    },
  },
  methods: {
    async loadStocks(params = {}) {
      this.loading = true;

      const [res, err] = await this.request(
        this.filter.warehouse.id
          ? `/api/v1/warehouses/${this.filter.warehouse.id}/stocks`
          : `/api/v1/stocks`,
        {
          params: {
            'page[size]': 5,
            sort: '-updatedAt',
            'fields[stocks]':
              'product_code,product_name,is_point,warehouse_code,stock_qty,free_qty,stock_ordered,free_ordered,stock_real,free_real',
            'filter[search]': this.filter.search,
            'filter[published]': false,
            'filter[not_warehouse_type]': 'pusat',
            ...params,
          },
        }
      );

      if (!err) {
        this.stocks = res;
      }

      this.loading = false;
    },
    onChangeWarehouse() {},
    onOpenDetail(stock) {
      this.detailModal.id = stock.id;
      this.detailModal.visible = true;
    },
    onChangePage(page) {
      this.loadStocks({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadStocks();
  },
};
</script>
